<template>

    <form ref="avaliacaocargoconceito-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-9">
                <label for="tagJobsId">Selecione o conceito</label>
                <select v-select="{ dataitem: 'AuxConceito', default: 'Selecione' }" v-model="model.conceitoId" class="form-control" name="conceitoId" required></select>
            </div>

            <div class="col-md-3">
                <div class="btn-group float-right" style="margin-top: 30px;">
                    <button type="button" class="btn btn-success " @click="executeCreate(model)">
                        <span>Adicionar</span>
                    </button>
                </div>

            </div>
        </div>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "avaliacaocargoconceito-form-create",
        props: { avaliacaoId: Number, cargoId: Number },
        mixins: [base],
        data: () => ({

            model: {},

            form: "avaliacaocargoconceito-form-create",
            
            resources: {
                create: 'avaliacaocargoconceito',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                this.model.avaliacaoId = this.avaliacaoId;
                this.model.cargoId = this.cargoId;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                var _valid = $form.checkValidity();
                if (!_valid) this.defaultErrorResult("Preencha todos os campos obrigatórios");
                return _valid;
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

